import React from 'react'
import { Link } from 'react-router-dom'
import FormSF from '../../../widgets/form/FormSF'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import CreditAssessmentDateModalSF from './CreditAssessmentDateModalSF'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'

const DocumentUploadUI = ({ context, account,
  onNPSubmit, npSubmitted, npSuccessMsg, npErrorList, setNPErrorList, npFileList,
  onSMSubmit, smSubmitted, smSuccessMsg, smErrorList, setSMErrorList,
  updateDateMode, onUpdateDateClick, onCancelDateClick, onAccountUpdate,
  onCopyToClipboard, copyToClipboardText, onDownloadFileClick, fileErrorList,
  onClientTxnsReuploadClick, clientTxnsReuploadSubmitted,
  onDeleteClick, deleteSubmitted
}) =>
  <CardUI title='Novel Patterns credit assessment' className='g_m_top_100'>
    <div className='g_flex_h g_flex_top'>
      <div>
        <div>
          {
            npFileList != null &&
            Object.entries(npFileList).map(([label, files]) =>
              <LRTableBodyUI
                key={label}
                className='g_m_top_25'
              >
                <LRTableRowUI
                  context={context}
                  className='g_flex_top'
                  left={
                    <div className='g_flex_v'>

                      <span>{label}</span>

                      {
                        files.map(item =>
                          <Link
                            key={item}
                            className='g_m_top_25'
                            onClick={onDownloadFileClick}
                            to='#'
                            data-type='np'
                            data-file-name={item}
                            data-folder={label}
                          >
                            {item}
                          </Link>
                        )
                      }

                    </div>
                  }
                  right={
                    <div
                    />

                  }
                />
              </LRTableBodyUI>
            )
          }
          {
            fileErrorList && fileErrorList.length > 0 &&
            <span>{fileErrorList[0].message}</span>
          }
        </div>
        <div>
          {
            account.documentStatus.npCAStatus === 'collected' &&
            <Link to={`/su/accounts/${account.accountId}/scoreParams`} onClick={() => window.scrollTo(0, 0)}>
              View
            </Link>
          }
        </div>
      </div>
      <div className='g_flex_v g_text_right'>
        <span><BadgeUI label={account.documentStatus.npCAStatus} /></span>
        <span className='g_muted'>{account.documentStatus.npStatusDateF1}</span>
      </div>
    </div>

    <div className='g_flex_h g_flex_left g_m_top_50'>
      Credit assessment date
      <span className='g_muted g_m_left_50'>{account.documentStatus.creditAssessmentDateF1}</span>
      <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onUpdateDateClick} />
    </div>

    {
      context.permissions.includes('su_superuser_business') &&
      <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
        label='Delete Client Bank Transactions'
        onClick={onDeleteClick} alignLeft={false}
        busy={deleteSubmitted}
      />
    }
    {
      context.permissions.includes('su_superuser_business') &&
      <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
        label='Reupload Client Txns from S3 to DB'
        onClick={onClientTxnsReuploadClick} alignLeft={false}
        busy={clientTxnsReuploadSubmitted}
      />
    }

    <CreditAssessmentDateModalSF context={context} account={account}
      updateMode={updateDateMode} onCancelClick={onCancelDateClick} onAccountUpdate={onAccountUpdate}
    />
  </CardUI>

export default DocumentUploadUI
